module.exports = __webpack_public_path__ + "static/media/icon-garante.4c9174cc.png";